import { DateType } from 'api/models';
import { HttpClient } from '../http-client';

export interface PersonalTask {
  personalTaskId: number;
  personalTaskName: string;
  status?: 'To do' | 'Completed';
  userId?: number;
  dueDate?: DateType | null;
}

class PersonalTaskHttpClient extends HttpClient {
  public async getPersonalTasks(): Promise<PersonalTask[]> {
    return this.get<PersonalTask[]>('/personal-tasks');
  }

  public async updatePersonalTask(
    personalTaskId: number,
    data,
  ): Promise<PersonalTask> {
    return this.put(`/personal-tasks/${personalTaskId}`, data);
  }

  public async createPersonalTask(data): Promise<PersonalTask> {
    return this.post('/personal-tasks', data);
  }

  public async deletePersonalTask(personalTaskId: number): Promise<void> {
    return this.delete(`/personal-tasks/${personalTaskId}`);
  }
}

export const PersonalTaskAPI = new PersonalTaskHttpClient();
